import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.get('engagement') !== 'collateral') return;

    const asset = query.get('asset') || 'AIVION information';
    setFormData((current) => ({
      ...current,
      message: `Please email me information about: ${asset}.`
    }));

    window.setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }, [location.search]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('/api/sendEmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      alert('Thank you for your inquiry! We will get back to you soon.');

      setFormData({
        name: '',
        email: '',
        company: '',
        message: ''
      });
    } else {
      alert('Something went wrong. Please try again.');
    }

  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Unable to send inquiry. Please try again later.');
  }
};

  return (
    <section id="contact" className="section">
      <div className="container">
        <div className="section-header">
          <h2>Let's Discuss Your AI Strategy.</h2>
          <p>Share your challenges. We'll outline how AIVION can help deliver measurable outcomes.</p>
        </div>

        <div className="contact-grid">
          <div className="contact-form-card">
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="company"
                placeholder="Company"
                value={formData.company}
                onChange={handleChange}
              />
              <textarea
                name="message"
                rows="6"
                placeholder="Tell us about your challenges"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button type="submit" className="case-cta-btn">Send Inquiry</button>
            </form>
          </div>

          <div className="contact-info-card">
            <h3>Contact Information</h3>

            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@aivion.ai</span>
            </div>

            <div className="contact-item contact-office">
              <i className="fas fa-location-dot"></i>
              <span className="contact-office-copy">
                <strong>European Headquarters</strong>
                Central Tech at Sciontec<br />
                31 Russell St,<br />
                Liverpool L3 5LJ.
              </span>
            </div>

            <div className="contact-item contact-office">
              <i className="fas fa-location-dot"></i>
              <span className="contact-office-copy">
                <strong>UK Office</strong>
                Wokingham, England.
              </span>
            </div>

            <div className="contact-item contact-office">
              <i className="fas fa-location-dot"></i>
              <span className="contact-office-copy">
                <strong>India</strong>
                <span>EPIC Block,</span>
                <span>Ambala College of Engineering and Applied Research,</span>
                <span>Ambala 133101.</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
